// core
import {axiosFetchBuilder} from "../core/Axios";
// store
import Store from "../stores";
import {INewsNoticeCount, INotificationsResponse} from "../core/models/Notifications";
import _ from "lodash";

enum Path {
    notices = "/notifications/notices",
    newsCount = "/notifications/count",
    actions = "/notifications/actions"
}

class BellNotificationsService {
    private static readonly bell = Store.bellNotifications;
    [Symbol.toStringTag] = this.constructor.name;

    static get items() {
        return BellNotificationsService.bell.items;
    }
    static get meta() {
        return BellNotificationsService.bell.meta;
    }

    static get newsNoticeCount() {
        return BellNotificationsService.bell.newsNoticeCount;
    }

    static async fetchNotifyNotifications(perPage?: number, page?: number) {
        try {
            const res: INotificationsResponse = await axiosFetchBuilder({
                url: Path.notices,
                loading: false,
                loadingBtn: true,
                params: {
                    "per-page": perPage,
                    page
                }
            });
            _.forEach(res.items, (i) => {
                const match =
                    /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/gim.exec(
                        i.text
                    );
                if (match?.[1]) {
                    i.text = _.replace(
                        i.text,
                        match[1],
                        `<a href="${match[1]}" target="_blank">${match[1]}</a>`
                    );
                }
            });

            if (BellNotificationsService.bell.items.length) {
                BellNotificationsService.bell.items = [
                    ...BellNotificationsService.bell.items,
                    ...res.items
                ];
            } else {
                BellNotificationsService.bell.items = res.items;
            }
            BellNotificationsService.bell.meta = res._meta;

            return res;
        } catch (err) {
            throw err;
        }
    }

    static async getNewsNoticeCount() {
        try {
            const res: INewsNoticeCount = await axiosFetchBuilder({
                url: Path.newsCount,
                params: {expand: "news_count,notice_count"}
            });

            BellNotificationsService.bell.newsNoticeCount = res;
        } catch (err) {
            throw err;
        }
    }

    static async postNewActions(notifications_id: (number | undefined)[]) {
        for (const notification_id of notifications_id) {
            try {
                await axiosFetchBuilder({
                    url: Path.actions,
                    method: "POST",
                    loading: false,
                    data: {notification_id, action: "view"}
                });
            } catch (err) {
                throw err;
            }
        }
    }
}

export default BellNotificationsService;
